<template>
  <div class="login">
    <div>
      <img src="../../assets/image/loginbg.png" class="loginBg" />
      <img src="../../assets/image/sumguo.png" class="logo" />
    </div>
    <!-- 表单部分 -->
    <van-cell-group class="cell_group">
      <van-form>
        <div class="login_label">登录</div>

        <van-field
          clearable
          label=" "
          left-icon="phone-circle-o"
          style="margin-top: 20px"
          v-model.trim="username"
          placeholder="请输入手机号"
          label-width="1"
          :error-message="usernameError"
          type="number"
        />
        <van-field
          clearable
          label=" "
          left-icon="eye-o"
          v-model.trim="password"
          placeholder="请输入密码"
          label-width="1"
          type="password"
        />
        <div class="forget_password" v-on:click="toReset()">忘记密码</div>
        <!-- 登陆按钮 -->
        <div class="btn-wrap" style="margin-top: 16px">
          <van-button type="primary" @click="hLogin" class="btn"
            >登陆</van-button
          >
        </div>
      </van-form>
    </van-cell-group>
  </div>
</template>

<script>
import { login } from "@/api/user";
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      usernameError: ""
    };
  },
  created() {
    let _this = this;
    const query = this.$route.query;
    if (query.uname && query.upwd) {
      let data = {
        mobile: query.uname,
        password: query.upwd
      };
      //  1)引入axios 2)根据接口要求，调用axios
      login(data)
        .then(resp => {
          let _data = resp.data;
          let _code = _data.code;
          if (_code == "0000") {
            let _result = _data.data.results;
            this.$store.commit("$_setToken", _result.token);
            sessionStorage.setItem("shopInfo", JSON.stringify(_result));
            _this.$toast.success("登录成功");
            _this.$router.push("/");
          } else {
            _this.$toast.fail(_data.msg);
          }
        })
        .catch(() => {
          _this.$toast.fail("登陆失败");
        });
    }
  },
  methods: {
    hTast() {},
    toReset() {
      this.$router.push("/forgetPassword");
    },
    async hLogin() {
      let _this = this;
      // 1.验证数据的有效性
      if (_this.username === "" || _this.password === "") {
        alert("账号或密码不能为空");
      } else {
        // 显示登陆中,loading...
        // $toast不是vue自带的功能，是由vant组件库提供的
        _this.$toast.loading({
          duration: 0, // 持续展示 toast,永远不会关闭
          mask: true, // 整体添加一个遮罩
          message: "登陆中..."
        });
        // 2. 向接口发请求，传递参数
        let data = {
          mobile: _this.username,
          password: _this.password
        };
        //  1)引入axios 2)根据接口要求，调用axios
        login(data)
          .then(resp => {
            let _data = resp.data;
            let _code = _data.code;
            if (_code == "0000") {
              let _result = _data.data.results;
              this.$store.commit("$_setToken", _result.token);
              sessionStorage.setItem("shopInfo", JSON.stringify(_result));
              _this.$toast.success("登录成功");
              _this.$router.push("/");
            } else {
              _this.$toast.fail(_data.msg);
            }
          })
          .catch(() => {
            _this.$toast.fail("登陆失败");
          });
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/login.less");
</style>
